export default {
  showHistoryDialog(state, payload) {
    state.showHistoryDialog = payload;
  },
  distributionMailFlag(state, payload) {
    state.distributionMailFlag = payload;
  },
  sourceAddress(state, payload) {
    state.sourceAddress = payload;
  },
  subject(state, payload) {
    state.subject = payload;
  },
  content(state, payload) {
    state.content = payload;
  },
  showCancelDialog(state, payload) {
    state.showCancelDialog = payload;
  },
  cancelItem(state, payload) {
    state.cancelItem = payload;
  },
};
